import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Problem from '../components/Problem';
import AboutFGC from '../components/AboutFGC';
import Services from '../components/Services';
import WhyUs from '../components/WhyUs';
import { ServiceComparison } from '../components/ServiceComparison';
import Bottleneck from '../components/Bottleneck';
import Hannah from '../components/Hannah';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { breadcrumbSchema, webPageSchema, faqSchema, PROD_ORIGIN } from '../lib/seo';
import { faqs } from '../data/content';

export default function HomePage() {
  const path = '/';
  const title = 'Startup Sales Consultant & Sales Function Design | Founder Growth Collective';
  const description = 'Sales function design and advisory for funded, founder-led startups. Build the structure, process and team needed to scale beyond founder-led sales.';

  const schemas = [
    webPageSchema({ path, name: title, description }),
    breadcrumbSchema([{ name: 'Home', path: '/' }]),
    faqSchema(faqs),
  ];

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }, []);

  return (
    <div className="bg-[#EBE4DE] text-[#2E2C28] min-h-screen">
      <SEO title={title} description={description} path={path} schemas={schemas} />
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <AboutFGC />
        <Services />
        <section className="pt-24 lg:pt-36"><div className="max-w-[1400px] mx-auto px-6 lg:px-12"><ServiceComparison /></div></section>
        <WhyUs />
        <Bottleneck />
        <Hannah />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
